export default __webpack_public_path__ + "static/media/sendWhatsapp.ab4ccb30.svg";